import styled from "styled-components";
import { IoClose } from "react-icons/io5";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: ${(props) => (props.Show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &:before {
    z-index: 1;
    content: "";
    width: 100%;
    height: 100%;
    background-color: var(--blur-bg-color);
    position: fixed;
    top: 0;
    left: 0;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  padding: 50px 50px 20px;
  border-radius: 5px;
  background-color: var(--secondary-bg-color);
  gap: 20px;
`;

export const SenhaContainer = styled.div`
  border: 2px solid var(--second-auxiliary-color);
  width: 100%;
  border-radius: 1rem;
  display: flex;
  padding: 0.6rem 0;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  gap: 1rem;
  position: relative;
  color: var(--primary-font-color);
`;

export const Copy = styled.div`
  position: absolute;
  right: 1rem;
  cursor: pointer;
  color: var(--primary-font-color);
  transition: opacity 0.2s;
  opacity: ${(props) => (props.show ? 1 : 0)};
`;

export const Copied = styled.div`
  color: var(--main-color);
  position: absolute;
  right: 1rem;
  cursor: pointer;
  transition: opacity 0.2s;
  opacity: ${(props) => (props.show ? 1 : 0)};
`;

export const Title = styled.h1`
  color: var(--primary-font-color);
`;

export const Button = styled.button`
  border: none;
  height: 40px;
  border-radius: 5px;
  padding: 10px 40px;
  background-color: var(--main-color);
  color: var(--button-text-color);
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 800;
  transition: transform 0.5s;
  transition: box-shadow 0.5s;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  }
`;

export const CloseIcon = styled(IoClose)`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 40px;
  cursor: pointer;
  transition: transform 0.2s;
  color: var(--primary-font-color);

  &:hover {
    transform: scale(1.2);
  }
`;
